import React, { Fragment } from "react";
import { connect as reduxConnect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import _ from "lodash";
import num from "numeral";
import { connect } from "formik";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { AutoCompleteInput, MoneyInput } from "components/Global/FastFormikMaterial";
import { CloseButton } from "components/Global/Buttons";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
&&&& {
  height: 34px;
}
`;

const RemoveLenderButton = styled(CloseButton)`
&& {
  top: 0px;
  right: -36px;
  color: #2196F3;
}
`;

const SideLabelLenderWithAllocationAndLead = ({ label, lenderAllocation, fieldName, options, placeholder, selectName, selectValue, isDisabled, hideLenderAllocationAndLeadCheckbox, hideDeleteButton, hasLeadSelected, index, removeLender, formik, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values, setFieldValue } = formik;
  const lenders = values.details.loanProvider;
  if (!lenders) {
    return null;
  }

  if (!selectName) {
    selectName = "name";
  }

  const { id, loanCompanyBridge } = lenders[index];
  const { isLead } = loanCompanyBridge;
  const valMoney = loanCompanyBridge.lenderAllocation;
  let selectedVal = _.find(options, { [selectValue]: id });

  if (!selectedVal) {
    selectedVal = { [selectName]: "--" };
  }

  const lenderName = `${selectedVal[selectName]} ${isLead && lenders.length > 1 ? "(Lead)" : ""}`;
  const moneyText = lenders.length > 1 ? valMoney : "";

  return (
    <LateralField label={label}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid container item xs={10}>
            <Grid item xs={7}>
              <ViewOnlyDiv>{lenderName}</ViewOnlyDiv>
            </Grid>
            <Grid item xs={4}>
              <ViewOnlyDiv placeholder={" "}>{moneyText ? num(moneyText).format("$0,0") : ""}</ViewOnlyDiv>
            </Grid>
          </Grid>
          <Grid item xs={1} />
        </Grid>)}
      {!isDisabled && (
        <Grid container item>
          <Grid container item xs={16} spacing={8}>
            <Grid item xs={7}>
              <StyledAutoCompleteInput
                formik={formik}
                fieldName={fieldName}
                options={options}
                selectName={selectName}
                selectValue={selectValue}
                {...otherProps}
                onChange={data => {
                  setFieldValue(`details.loanProvider[${index}].id`, data.value);
                  setFieldValue(`details.loanProvider[${index}].loanCompanyBridge.companyId`, data.value);
                }}
              />
            </Grid>

            {!hideLenderAllocationAndLeadCheckbox && <Grid item xs={3}>
              <MoneyInput
                fullWidth
                fieldName={lenderAllocation}
                placeholder={placeholder}
                {...otherProps}
                onChange={({ target }) => {
                  setFieldValue(`details.loanProvider[${index}].loanCompanyBridge.lenderAllocation`, target.value);
                }}
              />
            </Grid>}

            <Grid item xs={1}>
              {!hideLenderAllocationAndLeadCheckbox && <FormControlLabel
                label="Lead"
                labelPlacement="end"
                control={
                  <Checkbox
                    name={"isLead"}
                    defaultChecked={isLead}
                    onChange={({ target: { checked } }) => {
                      setFieldValue(`details.loanProvider[${index}].loanCompanyBridge.isLead`, checked);
                    }}
                    disabled={hasLeadSelected && !isLead}
                  />
                }
              />}
            </Grid>
            <Grid item xs={1}>
              {!hideDeleteButton && <RemoveLenderButton onClick={() => removeLender(index)} />}
            </Grid>
          </Grid>
        </Grid>)}
    </LateralField>
  );
};

const mapStateToProps = () => ({});

export default compose(
  withStyles(),
  connect,
  reduxConnect(mapStateToProps, {})
)(SideLabelLenderWithAllocationAndLead);
